export default async function buildForm(ctx = {}) {
  const mode = String(ctx?.mode || 'new').toLowerCase();
  const rowData = ctx?.rowData && typeof ctx.rowData === 'object'
    ? { ...ctx.rowData }
    : {};
  const readOnly = mode === 'view';

  // Exemplo de regra assíncrona antes de abrir o form.
  const generatedAt = new Date().toISOString();

  // Título do dialog do FORM custom.
  // Não altera labels dos botões do datagrid (new/view/edit).
  const titleByMode = {
    new: 'Cadastro Custom (Datagrid)',
    edit: 'Edição Custom (Datagrid)',
    view: 'Visualização Custom (Datagrid)',
  };

  return {
    element: 'form',
    parent: 'main',
    isDialog: true,
    kill: true,
    type: 'fieldset',
    title: titleByMode[mode] || titleByMode.new,
    buttons: readOnly
      ? [
        { text: 'Fechar' },
      ]
      : [
        { text: mode === 'edit' ? 'Salvar Alterações' : 'Salvar' },
        { text: 'Cancelar' },
      ],
    isGrid: true,
    content: [
      {
        element: 'text',
        name: 'name',
        label: 'Nome',
        row: 0,
        col: 0,
        value: rowData?.name || '',
        disabled: readOnly,
      },
      {
        element: 'text',
        name: 'key',
        label: 'Chave',
        row: 1,
        col: 0,
        value: rowData?.key || '',
        disabled: readOnly || mode === 'edit',
      },
      {
        element: 'text',
        name: 'generated_at',
        label: 'Gerado em',
        row: 2,
        col: 0,
        value: generatedAt,
        disabled: true,
      },
    ],
  };
}
